// 游戏试玩相关接口
import service from ".."

// 获取数据
export function gameIndex (params) {
  return service({
    method: 'GET',
    url: "/game/index",
    params
  })
}